import React from 'react';
import TermsAndConditionsContent
    from "../../components/AppSections/TermsAndConditionsSections/TermsAndConditionsContent";
import RequestYourKnaekID from "../../components/AppSections/HomepageSections/RequestYourKnaekID";
import FooterSection from "../../components/FooterSection/Footer";
import {Helmet} from "react-helmet";
import {appWords} from "../../config/Constants";
import {stringsTranslate} from "../../locales/CustomTranslater";

export default function TermsAndConditions() {
    const general_conditions_knaek = stringsTranslate(appWords.general_conditions_knaek);
    return (
        <div className="homepage-4 pt-5 mt-5">
            <Helmet>
                <title>Knaek - {general_conditions_knaek}</title>
            </Helmet>
            <div className="main">
                <TermsAndConditionsContent />
                <RequestYourKnaekID />
                <FooterSection/>
            </div>
        </div>
    );
}
